/**
 * 葡萄牙语
 */
var ptPT = {
  locale: 'pt-PT',
  Common: {
    pleaseInput: 'Por favor insira',
    pleaseSelect: 'Por favor selecione',
    confirm: 'Confirmar',
    clear: 'Limpar',
    cancel: 'Cancelar',
    next: 'Próximo',
    previous: 'Anterior',
    submit: 'Enviar',
    reset: 'Reiniciar'
  },
  Exception: {
    emptyData: 'Sem dados',
    error: 'Erro na página. Tente novamente mais tarde',
    networkError: 'Erro de rede'
  },
  List: {
    noMoreData: 'Não há mais dados',
    networkError: 'Erro de rede',
    clickRetry: 'Tentar novamente'
  },
  DateRangePicker: {
    startTime: 'Hora de início',
    endTime: 'Hora de fim',
    timeRange: 'Intervalo de tempo'
  }
};

export { ptPT as default };
